import { defaultDialogSetupBuilder } from '@/components/services/dialog/dialogSetup';

export default (invokeArgs = {}) => {
  const postfix = invokeArgs.amount > 1 ? 's' : '';
  const dialogSubject = `order${postfix}`;

  defaultDialogSetupBuilder(
    {
      isModalShown: true,
      confirmTitle: 'Cancel and return money',
      confirmText: `Are you sure you want to cancel
 <strong>${invokeArgs.amount}</strong> ${dialogSubject} and return money? This action cannot be undone.`,
      confirmBtnColor: 'invokedDialogRed',
      confirmBtnText: `Cancel and return money (${invokeArgs.amount})`,
      ...invokeArgs,
    },
  );
};
